export function TranscriptToggleButton({
  showTranscript,
  onToggle,
}: {
  showTranscript: boolean;
  onToggle: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onToggle}
      className={`p-2 rounded-full border transition-colors ${
        showTranscript
          ? 'bg-blue-600 border-blue-600 text-white'
          : 'border-gray-300 text-gray-600 hover:bg-gray-50'
      }`}
      title="Toggle transcript"
      aria-pressed={showTranscript}
    >
      <svg
        className="w-5 h-5"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
        />
      </svg>
    </button>
  );
}
